module.exports = __webpack_public_path__ + "img/xbox.ac6d4ba4.svg";